import React, { useEffect, useRef } from 'react';

function LiveTranscript({ entries }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [entries]);

  if (!entries || entries.length === 0) {
    return (
      <div style={styles.empty}>
        <MicIcon />
        <p style={styles.emptyText}>Transcript will appear here once recording starts...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {entries.map((entry, idx) => (
        <div key={idx} style={styles.entry}>
          <span style={{
            ...styles.role,
            color: entry.role === 'CLINICIAN' ? '#2563eb' : '#059669'
          }}>
            {entry.role === 'CLINICIAN' ? 'Dr' : 'Patient'}:
          </span>
          <span style={{
            ...styles.text,
            ...(entry.isPartial ? styles.partial : {})
          }}>
            {entry.text}
          </span>
          {entry.timestamp && (
            <span style={styles.timestamp}>
              {formatTimestamp(entry.timestamp)}
            </span>
          )}
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}

function formatTimestamp(seconds) {
  if (!seconds && seconds !== 0) return '';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

function MicIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
      <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z" />
      <path d="M19 10v2a7 7 0 01-14 0v-2" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
  );
}

const styles = {
  container: {
    flex: 1,
    overflowY: 'auto',
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  empty: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    color: '#9ca3af',
    padding: '40px 20px'
  },
  emptyText: {
    margin: 0,
    fontSize: '14px',
    textAlign: 'center'
  },
  entry: {
    display: 'flex',
    gap: '8px',
    alignItems: 'baseline',
    padding: '6px 0',
    borderBottom: '1px solid #f3f4f6',
    lineHeight: '1.5'
  },
  role: {
    fontWeight: 600,
    fontSize: '13px',
    whiteSpace: 'nowrap',
    minWidth: '60px'
  },
  text: {
    fontSize: '14px',
    color: '#1f2937',
    flex: 1
  },
  partial: {
    fontStyle: 'italic',
    color: '#6b7280'
  },
  timestamp: {
    fontSize: '11px',
    color: '#9ca3af',
    whiteSpace: 'nowrap',
    fontFamily: 'monospace'
  }
};

export default LiveTranscript;
